"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "setteville": {
    "84dd4162": [{
      "hkey": "81ffece0",
      "slug": "campo",
      "name": "Campo",
      "primary": true,
      "skipSearch": false
    }],
    "ec7b004a": [{
      "hkey": "863af2b0",
      "slug": "colmirano",
      "name": "Colmirano",
      "primary": true,
      "skipSearch": false
    }],
    "71a7bbb0": [{
      "hkey": "3e5e9f96",
      "slug": "fener",
      "name": "Fener",
      "primary": true,
      "skipSearch": false
    }],
    "070c62cf": [{
      "hkey": "15e0338c",
      "slug": "scalon",
      "name": "Scalon",
      "primary": true,
      "skipSearch": false
    }],
    "62164d37": [{
      "hkey": "15114956",
      "slug": "caorera",
      "name": "Caorera",
      "primary": true,
      "skipSearch": false
    }],
    "bbb1032f": [{
      "hkey": "8830cd8d",
      "slug": "marziai",
      "name": "Marziai",
      "primary": true,
      "skipSearch": false
    }],
    "6f4e0ff0": [{
      "hkey": "ec93fde9",
      "slug": "alano-di-piave",
      "name": "Alano di Piave",
      "primary": true,
      "skipSearch": false
    }],
    "e8d46cb1": [{
      "hkey": "97d19dea",
      "slug": "carpen",
      "name": "Carpen",
      "primary": true,
      "skipSearch": false
    }],
    "8d599270": [{
      "hkey": "3d6aa80a",
      "slug": "santa-maria",
      "name": "Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "f519863a": [{
      "hkey": "b39be6ec",
      "slug": "schievenin",
      "name": "Schievenin",
      "primary": true,
      "skipSearch": false
    }],
    "b856f930": [{
      "hkey": "f2fdcc27",
      "slug": "quero",
      "name": "Quero",
      "primary": true,
      "skipSearch": false
    }],
    "940d0b41": [{
      "hkey": "11ca0a6e",
      "slug": "vas",
      "name": "Vas",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;